import { Link as RouterLink } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-[#1a1a2e] text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>韩漫网</h3>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href={siteInfo.social.weibo} rel="nofollow noopener noreferrer" target="_blank" aria-label="微博" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-qq-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map(cat => (
                <li key={cat.slug}>
                  <RouterLink to={`/category/${cat.slug}`} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </RouterLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><RouterLink to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</RouterLink></li>
              <li><RouterLink to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新更新</RouterLink></li>
              <li><RouterLink to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</RouterLink></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-50/40">
            &copy; {siteInfo.year} 韩漫网 hanmanwang.com - 全网最全无删减韩国漫画在线阅读平台
          </p>
          <p className="text-sm text-background-50/30">
            <a href="#" className="hover:text-primary-400 transition-colors">京ICP备2024000001号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}